import React from "react";

// Renders an image honoring a focal point (object-position) + zoom + rotation, inside a fixed container.
export default function FocalImage({ img, alt = "", className = "", testid }) {
  const x = img?.pos_x ?? 50;
  const y = img?.pos_y ?? 50;
  const zoom = img?.zoom ?? 1;
  const rotate = img?.rotate ?? 0;
  return (
    <img
      src={img?.url}
      alt={alt}
      data-testid={testid}
      className={`w-full h-full object-cover ${className}`}
      style={{
        objectPosition: `${x}% ${y}%`,
        transform: `scale(${zoom}) rotate(${rotate}deg)`,
        transformOrigin: `${x}% ${y}%`,
      }}
    />
  );
}
